export const HELPCENTER_LANGUAGES = ['en', 'nl'];

export const MAX_NAME_LENGTH = 100;
export const BASE_VU_WIDTH = 320;

export const AVAILABLE_POSITIONS = [
  {
    type: 'tl',
    title: 'company.settings.logos.positions.top_left',
  },
  {
    type: 'tr',
    title: 'company.settings.logos.positions.top_right',
  },
  {
    type: 'tc',
    title: 'company.settings.logos.positions.top_center',
  },
  {
    type: 'bl',
    title: 'company.settings.logos.positions.bottom_left',
  },
  {
    type: 'br',
    title: 'company.settings.logos.positions.bottom_right',
  },
  {
    type: 'bc',
    title: 'company.settings.logos.positions.bottom_center',
  },
];
